/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const __vue_script__ = {
    name: 'DuplicateItemsModal',

    props: {
        items: {
            type: Array,
            required: true
        },

        event: {
            type: Object,
            required: true
        },

        fpType: {
            type: String,
            required: true
        },

        onComplete: {
            type: Function,
            default: () => {}
        },

        onError: {
            type: Function,
            default: () => {}
        }
    },

    data() {
        return {
            title: this.$t('listings.labels.duplicate_items', [this.fpType]),
            progress: 0,
            running: false
        };
    },

    methods: {
        async duplicateItems() {
            try {
                this.running = true;

                const itemIds = this.items.map(i => i._id);
                const { data: { jobId } } = await this.$services.documents.duplicateDocs(this.event._id, this.fpType, itemIds, this.$t('general.copy_of'));

                await this.$services.jobs.waitFor({
                    jobId,
                    resultPath: this.$utils.url.interpolateUrl(this.$const.QUEUE_JOB_STATUS_PATH, { jobId: jobId.toString() }),
                    updateUIProgress: progress => this.progress = progress
                });

                this.track('success');
                this.onComplete();
                this.$emit('close');
            } catch (error) {
                console.error('[DuplicateItemsModal] Error duplicating items', error);

                this.$notify({
                    group: 'flashes',
                    title: this.$i18n.t('general.error_occurred').toString(),
                    text: this.$i18n.t('listings.messages.cannot_duplicate', [this.fpType]).toString(),
                    type: 'error',
                });

                this.track('error');
                this.onError(error);
            } finally {
                this.running = false;
            }
        },

        close() {
            this.track('aborted');
            this.$emit('close');
        },

        async track(status) {
            try {
                await this.$services.track.track('duplicate_end', {
                    countSelectedItems: this.items.length,
                    dataType: this.fpType,
                    status
                });
            } catch (error) {
                console.error('[DuplicateItemsModal] Error tracking duplication', error);
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"duplicate-items-modal modal-wrapper"},[_c('div',{staticClass:"modal-header"},[_c('a',{staticClass:"close",attrs:{"href":"#"},on:{"click":function($event){return _vm.close()}}}),_c('h3',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"modal-body"},[(!_vm.running)?[_c('p',[_vm._v(_vm._s(_vm.$tc('listings.labels.duplicate_items_message', _vm.items.length, [_vm.items.length, _vm.fpType])))])]:[_c('p',[_vm._v(_vm._s(_vm.$t('general.long_operation_warning')))]),_c('progress-bar',{attrs:{"progress":_vm.progress}})]],2),(!_vm.running)?_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.close()}}},[_vm._v(_vm._s(_vm.$t('general.cancel')))]),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.duplicateItems()}}},[_vm._v(_vm._s(_vm.$t('general.confirm')))])]):_vm._e()])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "DuplicateItemsModal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__